import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireAdmin, RequireAuth } from './guards';
import { routePatterns } from './paths';
import { AdminPage } from '../pages/AdminPage';
import { AdminCampaignDetailPage } from '../pages/AdminCampaignDetailPage';
import { AdminTaskTypePreviewPage } from '../pages/AdminTaskTypePreviewPage';
import { AdminNexusUploadDetailPage } from '../pages/AdminNexusUploadDetailPage';
import { BrowseTasksPage } from '../pages/BrowseTasksPage';

function admin(element: React.ReactElement): React.ReactElement {
  return (
    <RequireAuth>
      <RequireAdmin>{element}</RequireAdmin>
    </RequireAuth>
  );
}

export const adminRoutes: RouteObject[] = [
  { path: routePatterns.admin, element: admin(<AdminPage />) },
  { path: routePatterns.adminCampaign, element: admin(<AdminCampaignDetailPage />) },
  { path: routePatterns.adminTool, element: admin(<AdminPage />) },
  { path: routePatterns.adminTaskType, element: admin(<AdminTaskTypePreviewPage />) },
  { path: routePatterns.adminNexusUpload, element: admin(<AdminNexusUploadDetailPage />) },
  { path: routePatterns.browseTasks, element: admin(<BrowseTasksPage />) },
];
